import { PendingOrganizationComponent } from "@/components/pending";
import { Button } from "@papier/ui/components/ui/button";
import { createFileRoute, Link, linkOptions, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/organization")({
  component: RouteComponent,
  wrapInSuspense: true,
  pendingComponent: () => <PendingOrganizationComponent />,
  errorComponent: ({ error }) => <div>{error.message}</div>,
  head: () => ({
    meta: [{ title: "Organization" }],
  }),
});

const navItems = linkOptions([
  { to: "/organization/settings", label: "Settings" },
  { to: "/organization/members", label: "Members" },
  { to: "/organization/api-keys", label: "API Keys" },
  { to: "/organization/billing", label: "Billing" },
]);

function RouteComponent() {
  return (
    <main className="flex w-full grow flex-col gap-4 md:flex-row md:gap-12">
      <nav>
        <div className="hidden md:block">
          <div className="flex w-48 flex-col gap-1 lg:w-60">
            {navItems.map((item) => (
              <Button
                variant="ghost"
                asChild
                key={item.label}
                className="text-foreground/70 w-full justify-start px-4 transition-none"
              >
                <Link
                  key={item.label}
                  to={item.to}
                  activeProps={{ className: "!text-foreground font-semibold" }}
                >
                  {item.label}
                </Link>
              </Button>
            ))}
          </div>
        </div>
      </nav>

      <div className="w-full">
        <Outlet />
      </div>
    </main>
  );
}
